module.exports = __webpack_public_path__ + "img/img_3.21125b7c.png";